import React, { Component } from 'react';
import {Link} from 'react-router-dom' // used by the commented-out notice below
import Form from './Form'
import CartBar from './CartBar'
import InfoHours from '../../react/InfoHours';
import './coral.scss'
class CoralCafe extends Component {
  render() {
    return (
      <div className="coralcafe">
      </div>
    );
  }
}

export const pages = [

  // {path: "menu", label: "Menu" },
  {path: "/order", label: "Order" },
  {path: "/signup", label: "", hidden: true, component: Form },
  // {path: "https://nohoramenkitchenla.com/contact/", label: "Contact", external: true },

]

// "/" and "/menu" belong to the Astro marketing site in production (see
// ./_redirects); this app only owns the ordering routes.
export const customOrderAppPaths = ["/order"]

export {CartBar as StickyTopBar}

// No SiteNav export: the only link it held was "Order", which is where this app
// already lands. App.js renders the nav only when this module exports one, so
// omitting it removes the bar. `pages` above still registers the /signup route.

export class Header extends Component {
  render() {
    return (
      <div className="order-benefits-wrapper">
        {/* <div className="john">
          <div className="picture">
            <img src="https://afag.imgix.net/coral-cafe/john.jpg?w=800&auto=format" alt="John Leousis in front of coral cafe" />
          </div>

          <div className="text">
            <p>It is with a heavy heart that we inform all our customers that co owner John Leousis passed away.</p>
            <p>In his memory Coral Cafe will be closed Monday the 22nd and Tuesday the 23rd. We will reopen Wednesday the 24th for normal hours 7am to 11pm</p>
            <p>If you wish you may <Link to="/signup">leave us a message</Link>.</p>
          </div>

          <br style={{
            clear: "left"
          }}
          />
        </div> */}
        <div className="order-benefits">

          <div className="text">
            <p>Order below for Togo & Delivery</p>
            <p>All Week: <br/>7am - 11pm</p>
            <div style={{textAlign: "right"}}>
          
              <a
                style={{color: "white"}}
                href="/public/coral-cafe-menu-2025.pdf">pdf menu</a>
            </div>
          </div>

         



        </div>
        {/* <InfoHours></InfoHours> */}
      </div>
    );
  }
}

export default CoralCafe;
